import Reactor from '../reactor';

export default {
    SELECT_ROSTER_TERM_BID: 'SELECT_ROSTER_TERM_BID',
    SELECT_SCHOOL_BID: 'SELECT_SCHOOL_BID',
    SELECT_CLASS_BID: 'SELECT_CLASS_BID',
    SELECT_INSTRUCTOR_BID: 'SELECT_INSTRUCTOR_BID',
    SELECT_STUDENT_BID: 'SELECT_STUDENT_BID',
    STORE_SCHOOLS: 'STORE_SCHOOLS',
    SELECTED_SN_ENABLED_CLASS: 'SELECTED_SN_ENABLED_CLASS',
    STORE_CLASSES: 'STORE_CLASSES',
    STORE_INSTRUCTORS: 'STORE_INSTRUCTORS',
    STORE_STUDENTS: 'STORE_STUDENTS',
    CLEAR_ROSTER_DATA: 'CLEAR_ROSTER_DATA',

    selectRosterTermBid(rosterTermBid) {
        Reactor.dispatch(this.SELECT_ROSTER_TERM_BID, rosterTermBid);
    },
    selectSchoolBid(schoolBid) {
        Reactor.dispatch(this.SELECT_SCHOOL_BID, schoolBid);
    },
    selectClassBid(classBid) {
        Reactor.dispatch(this.SELECT_CLASS_BID, classBid);
    },
    selectInstructorBid(instructorBid) {
        Reactor.dispatch(this.SELECT_INSTRUCTOR_BID, instructorBid);
    },
    selectStudentBid(studentBid) {
        Reactor.dispatch(this.SELECT_STUDENT_BID, studentBid);
    },
    storeSchools(schools) {
        Reactor.dispatch(this.STORE_SCHOOLS, schools);
    },
    storeClasses(classes) {
        Reactor.dispatch(this.STORE_CLASSES, classes);
    },
    storeInstructors(instructors) {
        Reactor.dispatch(this.STORE_INSTRUCTORS, instructors);
    },
    storeStudents(students) {
        Reactor.dispatch(this.STORE_STUDENTS, students);
    },
    clearRosterData() {
        Reactor.dispatch(this.CLEAR_ROSTER_DATA);
    },
};
